import React, { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';  
import './App.css';
import Home from './components/pages/Home';
import Services from './components/pages/Services';
import Products from './components/pages/Products';
import Skills from './components/pages/Skills';
import 'bootstrap/dist/css/bootstrap.min.css';
import Achivement from './components/pages/Achivement';
import PhotoEditing from './components/pages/PhotoEditing';
import Contact from './components/Contact';
import Hobbies from './components/Hobbies';
import Loader from './Loader';
import GraphicDesign from './components/pages/GraphicDesign';
import IllustrationWork from './components/pages/IllustrationWork';
import { Outlet } from 'react-router-dom';

function App() {
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000); 
  }, []);

  const routes = [
    {
      path: '/',
      element: (
        <>
          <Navbar />
          {loading ? (
            <Loader />
          ) : (
            <Outlet />
          )}
          <Footer /> 
        </>
      ),
      children: [
        { path: '/', element: <Home /> },
        { path: '/Services', element: <Services /> },
        { path: '/Products', element: <Products /> },
        { path: '/Skills', element: <Skills /> },
        { path: '/Achivement', element: <Achivement /> },
        { path: '/PhotoEditing', element: <PhotoEditing /> },
        { path: '/Contact', element: <Contact /> },
        { path: '/Hobbies', element: <Hobbies /> },
        { path: '/GraphicDesign', element: <GraphicDesign /> },
        { path: '/IllustrationWork', element: <IllustrationWork /> },
      ],
    },
  ];

  const router = createBrowserRouter(routes);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
